export interface IHydrologicalDischargeNumberFormatter {
  (value:string|number, defaultText?:string):string;
}

export default function HydrologicalDischargeNumberFormatter() {
  return (input:string|number, defaultText:string = '---'):string => {
    if (input == null) {
      return defaultText;
    }
    const value = Number.parseFloat(input.toString());
    if (Number.isNaN(value)) {
      return defaultText;
    }

    const decimals = countDecimals(value);
    let decimalsForRounding: number;
    
    if (
      (decimals === 1 || decimals === 0) ||
      (decimals === 2 && value < 10)
    ) {
      decimalsForRounding = decimals;
    } else {
      decimalsForRounding = decimals - 1;
    }

    const tenPowerByDecimalsForRounding = Math.pow(10, decimalsForRounding);

    if (value >= 1000) {
      return (Math.round(value / 10) * 10).toString();
    }
    else {
      return (Math.round(value * tenPowerByDecimalsForRounding) / tenPowerByDecimalsForRounding).toPrecision(3);
    }
  };
}

function countDecimals(value: number) {
    if (Math.floor(value) !== value)
        return value.toString().split(".")[1].length || 0;
    return 0;
}


/** WEBPACK FOOTER **
 ** ./app/utils/hydrological-discharge-number.formatter.ts
 **/